import { render, staticRenderFns } from "./Occup.vue?vue&type=template&id=92cbd500&scoped=true&"
import script from "./Occup.vue?vue&type=script&lang=js&"
export * from "./Occup.vue?vue&type=script&lang=js&"
import style0 from "./Occup.vue?vue&type=style&index=0&id=92cbd500&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92cbd500",
  null
  
)

export default component.exports